import React, { useEffect, useState, useCallback } from "react";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumb } from "react-bootstrap";
import TrancheList from "../../components/TrancheBot/TrancheList";
import "./index.css";
import TrancheSearch from "../../components/TrancheBot/TrancheSearch";
import { getAllTrancheBotData, tranchePolling } from "../../service/api";

const TrancheBot = () => {
  const [tranches, setTranches] = useState([]);
  const [isListLoading, setIsListLoading] = useState(true);

  const isGenerating = tranches.some(
    (item) => item.currentStatus === "Generating"
  );

  const fetchAllTranches = async () => {
    try {
      const res = await getAllTrancheBotData();
      setTranches(res?.data?.data || []);
    } catch (error) {
      console.error("Failed to fetch tranches:", error);
    } finally {
      setIsListLoading(false);
    }
  };

  const pollTrancheUpdates = useCallback(async () => {
    try {
      const response = await tranchePolling();

      if (response?.data?.length > 0) {
        setTranches((prev) =>
          prev.map((tranche) => {
            const update = response.data.find((u) => u._id === tranche._id);
            return update
              ? { ...tranche, currentStatus: update.currentStatus }
              : tranche;
          })
        );
      }
    } catch (error) {
      console.warn("Polling error:", error.message);
    }
  }, []);

  useEffect(() => {
    fetchAllTranches();
  }, []);

  useEffect(() => {
    if (!isGenerating) return;

    //polling every 10 seconds
    const intervalId = setInterval(() => {
      pollTrancheUpdates();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, [isGenerating, pollTrancheUpdates]);

  return (
    <div className="mx-3">
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{
              className: "breadcrumb-dark breadcrumb-transparent",
            }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Tranche Bot</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <h1 className="heading">Tranche Bot</h1>
      <div className="tranche-container">
        <div className="tranche-form">
          <TrancheSearch fetchAllTranches={fetchAllTranches} />
        </div>
        <div className="tranche-list">
          <TrancheList
            tranches={tranches}
            isListLoading={isListLoading}
            fetchAllTranches={fetchAllTranches}
          />
        </div>
      </div>
    </div>
  );
};

export default TrancheBot;
